import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <header className="header">
      <h1>My Todo App</h1>
    </header>
  );
};

export default Header;
